import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withStyles } from '@material-ui/core/styles'
import { create, list, deleteEntity } from 'actions/data'
// import { DATA_API_URL } from 'utils/AllURLs'
import { v4 as uuidv4 } from 'uuid'

const styles = theme => ({})

const mapStateToProps = null

const mapDispatchToProps = dispatch =>
  bindActionCreators({ create, list, deleteEntity }, dispatch)

class Testing extends Component {
  render() {
    return (
      <div>
        <button
          onClick={() => console.log(uuidv4())}

          // // creates a userpin:
          // onClick={() => {
          //   // console.log('')
          //   this.props.create({
          //     entityType: 'userpin',
          //     entity: {
          //       pinned_entity_id: '142',
          //       secondary_id: 'contactgroup',
          //     },
          //     url: `${DATA_API_URL}/userpin`,
          //     hasSchema: false,
          //     snackbarMessage: 'Entity now pinned',
          //   })
          // }}

          // // lists all userpins for user:
          // onClick={() => {
          //   this.props.list(
          //     'userpin',
          //     null,
          //     `${DATA_API_URL}/userpin/username-entity`
          //   )
          // }}

          // // lists all contact userpins for user:
          // onClick={() => {
          //   this.props.list(
          //     'userpin',
          //     null,
          //     `${DATA_API_URL}/userpin/username-entity?secondary_id=campaign`,
          //   )
          // }}

          // // delete userpin (in UI this would be unpinning)
          // onClick={() => {
          //   this.props.deleteEntity(
          //     'cfe29475-c5a6-4b74-9629-81ba5d4be601',
          //     'userpin',
          //     `${DATA_API_URL}/userpin/${'cfe29475-c5a6-4b74-9629-81ba5d4be601'}`,
          //     'Entity unpinned'
          //   )
          // }}
        >
          Click here
        </button>
      </div>
    )
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(Testing))
